<div>
  <p>{{ error?.message }}</p>
  <button pButton type="button" class="mr-3" (click)="sendOk()">Ok</button>
</div>
